import React, {useState, useEffect, Fragment, JSX, ReactNode} from 'react';
import axios from 'axios';
import hljs from 'highlight.js';
import {STRAPI_ARTICLES, STRAPI_ARTICLES_ALL, STRAPI_ARTICLES_FEATURED, STRAPI_ROOT} from "../services/strapi";
import DynamicZone from "../shared/DynamicZone";
import SharedImage from "../shared/SharedImage";
import {getDynamicZoneQuery} from "../services/strapi";
import SharedGallery, {iGalleryItem} from "../shared/SharedGallery";


export interface iArticle {
    title: string;
    imageUrl: string;
    imageAlt: string;
    description: string;
    url: string
    createdAt: Date;
    publishedAt: Date;
    content: any;
    id: number;
}
//
// export function ArticleComp(props: iArticle) {
//
//
//     return <div className="h-100 d-flex flex-column">
//         <a href={`/articles/${props.url}`}>
//             <h6>{props.title}</h6>
//         </a>
//         <p>{props.description}</p>
//
//             {props.imageUrl ?
//                 <a href={`/articles/${props.url}`} className="no-link-style h-100 d-flex flex-column">
//                 <div style={{flex: 1, minHeight: 0, overflow: 'hidden'}}>
//                     <SharedImage key={props.imageUrl} imageUrl={props.imageUrl} altText={props.imageAlt}/>
//                 </div></a> :
//                 <></>}
//     </div>
// }
//
//
// export function ArticleComp(props: iArticle) {
//
//
//     return <div className="h-100 d-flex flex-column">
//         <a href={`/articles/${props.url}`}>
//             <h6>{props.title}</h6>
//         </a>
//         <p>{props.description}</p>
//
//             {props.imageUrl ?
//                 <a href={`/articles/${props.url}`} className="no-link-style h-100 d-flex flex-column">
//                 <div style={{
//                     flex: 1,
//                     minHeight: 0,
//                     overflow: 'hidden',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center'
//                 }}>
//                     <img
//                         src={props.imageUrl}
//                         alt={props.imageAlt}
//                         style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'contain',
//                             objectPosition: 'center',
//                             display: 'block'
//                         }}
//                     />
//                 </div></a> :
//                 <></>}
//     </div>
// }


export function ArticleComp(props: iArticle) {


    return <div className="h-100 d-flex flex-column">
        <a href={`/articles/${props.url}`}>
            <h4>{props.title}</h4>
        </a>
        <p>{props.description}</p>

            {props.imageUrl ?
                <a
                    href={`/articles/${props.url}`}
                    className="no-link-style d-flex flex-column"
                    style={{
                        flex: 1,
                        minHeight: 0
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0.25rem',
                            boxSizing: 'border-box'
                        }}
                    >
                        <img
                            src={props.imageUrl}
                            alt={props.imageAlt}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                                objectPosition: 'center',
                                display: 'block'
                            }}
                        />
                    </div>
                </a> :
                <></>}
    </div>
}

export function ArticlePage(props: { onlyFeatured?: boolean, countLimit?: number, galleryHeight?: number }) {
    const [articles, setArticles] = useState<iArticle[]>([])

    const onlyFeatured = props.onlyFeatured || false;

    let galleryHeight = props.galleryHeight || 400;

    useEffect(() => {

        let articleArr: iArticle[] = [];

        axios.get(onlyFeatured ? STRAPI_ARTICLES_FEATURED : STRAPI_ARTICLES_ALL).then((d) => {

            for (let n of d['data']['data']) {


                articleArr.push({
                    content: [],
                    imageUrl: n['cover'] ? `${STRAPI_ROOT}${n['cover']['url']}` : '',
                    imageAlt: n['cover'] ? `${STRAPI_ROOT}${n['cover']['alternativeText']}` : '',
                    id: n['id'],
                    title: n['title'],
                    description: n['description'],
                    url: n['slug'],
                    createdAt: new Date(n['createdAt']),
                    publishedAt: new Date(n['publishedAt'])
                })

            }

            setArticles(articleArr);
        });

    }, []);

    const all_articles: iGalleryItem[] = [];

    for (let n of articles) {

        all_articles.push({
            key: n.url,
            content: <ArticleComp {...n}/>
        })
    }

        return <div className="row justify-content-center">
            <div className="col-sm-12 col-lg-10">
                <SharedGallery
                    items={all_articles}
                    maxVisibleCount={3}
                    itemHeight={`${galleryHeight}px`}
                    useBootstrapGrid={!onlyFeatured}
                />
            </div>
        </div>
}

export interface iArticleOne {
    url: string
}

export function ArticleOne(props: iArticleOne) {

    const [article, setArticle] = useState<iArticle>(undefined!);

    // useEffect(() => {
    //     hljs.highlightAll();
    // }, [article]);

    useEffect(() => {
        let reqUrl2 = getDynamicZoneQuery(STRAPI_ARTICLES, {slug: props.url, populate: ["cover"]})

        axios.get(reqUrl2).then((d) => {


            if (d['data']['data'].length === 0) {
                setArticle({
                    content: '',
                    imageUrl: '',
                    imageAlt: '',
                    id: 0,
                    title: 'Not found',
                    description: '',
                    url: '',
                    createdAt: new Date(),
                    publishedAt: new Date()
                });
                return
            }
            let n = d['data']['data'][0];

            let articleImgUrl = n['cover'] ? `${STRAPI_ROOT}${n['cover']['url']}` : '';
            let articleImgAlt = n['cover'] ? `${STRAPI_ROOT}${n['cover']['alternativeText']}` : '';

            document.title = 'Status Code 200 - ' + n['title'];

            setArticle({
                content: n['content'],
                imageUrl: articleImgUrl,
                imageAlt: articleImgAlt,
                id: n['id'],
                title: n['title'],
                description: n['description'],
                url: n['slug'],
                createdAt: new Date(n['createdAt']),
                publishedAt: new Date(n['publishedAt'])
            });
        });
    }, []);

    let outEl = <></>


    if (article) {

        let featuredImage = <></>;

        if (article.imageUrl) {
                featuredImage = featuredImage = <SharedImage
                    key={article.imageUrl}
                    imageUrl={article.imageUrl}
                    altText={article.imageAlt}
                    maxWidth="720px"
                    maxHeight="420px"
                />        }


        outEl = <div className="row justify-content-center">
            <div className="col-sm-10 col-lg-8">
                <h3>{article.title}</h3>
                {featuredImage}
                <p>{article.description}</p>
                <div>
                    <DynamicZone content={article.content}/>

                    <span>created: {article.createdAt.toLocaleDateString() + " " +
                        article.createdAt.toLocaleTimeString()}</span>
                </div>
            </div>
        </div>
    }

    return outEl;
}
